module.exports = __webpack_public_path__ + "static/media/company_info_w.e696c2a6.svg";